import "./HomeLeftSection.css";
import { Button } from "../../components/forms/Form";
import { Link } from "react-router-dom";

export default function HomeLeftSection() {
  return (
    <div className="home-left-section">
      <h1>
        Crea il tuo
        <br />
        eCommerce
        <br />
        per la Farmacia
      </h1>
      <p className="descrizione">
        Vendi online con Farmakom, l’unico framework SaaS dedicato alla farmacia e integrato con tutti i gestionali e con i grossisti che servono le farmacie.
      </p>
      <Link
        style={{
          alignSelf: "flex-end",
          height: "7vh",
          marginTop: 16,
        }}
        className="button"
        to="/register"
      >
        Inizia da qui
      </Link>
    </div>
  );
}
